export default class BookPanel {
  constructor(btnOpenPanel, panel) {
    this.btnOpenPanel = btnOpenPanel;
    this.panel = panel;
    this.patchedSelects = [];
  }

  init() {
    this.btnOpenPanel?.addEventListener("click", (e) => {
      if (!this.panel?.classList.contains("is-open")) {
        this.panel?.classList.add("is-open");
        this.panel?.showModal();
        document.querySelector("html")?.classList.add("overflow-hidden");
      }
    });

    this.panel?.querySelector(".js-modal-close")?.addEventListener("click", (e) => {
      this._resetPanel(); 
      this.panel?.classList.remove("is-open"); 
      this.panel?.close(); 
      document.querySelector("html")?.classList.remove("overflow-hidden"); 
    });

    this.panel?.addEventListener("close", (e) => {
      this._resetPanel();
      this.panel?.classList.remove("is-open");
      document.querySelector("html")?.classList.remove("overflow-hidden");
    });

    this._initBookPanelForm();
  }

  _resetPanel() {
    this.panel?.querySelectorAll(".is-active")?.forEach(el => {
      el.querySelector("img")?.setAttribute("src", el.querySelector("img").getAttribute("data-imgpos"));
      el.classList.remove("is-active");
    });
    this.panel?.querySelectorAll(".is-hidden")?.forEach(el => el.classList.remove("is-hidden"));
    this.panel?.querySelectorAll("input")?.forEach(input => input.checked = false);
    this.panel?.querySelectorAll("select")?.forEach(select => select.value = select.querySelector("option").value);
    this.panel?.querySelector(".js-locations")?.classList.add("is-disabled");
  }

  _initBookPanelForm() {
    if (this.panel) {
      const form = this.panel.querySelector(".js-form-book-panel");      
      if (form) {
        this._showAndHideOptions(form);
        const btnSubmit = form.querySelector(".js-btn-submit");        
        btnSubmit?.addEventListener("click", (e) => {
          e.preventDefault();
          const locationsCont = form.querySelector(".js-locations");
          if (locationsCont) {
            const input = locationsCont.querySelector(".single-input-wrap:not(.is-hidden) input[data-checked='true']");
            if (input?.closest(".single-input-wrap")?.querySelector("select:not(.is-hidden)")) {
              window.open(
                input?.closest(".single-input-wrap")?.querySelector("select:not(.is-hidden)")
                  .querySelector(`option[value='${input?.closest(".single-input-wrap")?.querySelector("select:not(.is-hidden)").value}']`)?.getAttribute("data-link"),
                "_self"
              );

            } else {
              window.open(
                input?.getAttribute("data-link"),
                "_self"
              );
            }
          }
        });
      }      
    }
  }

  _showAndHideOptions(form) {
    const inputs = form.querySelectorAll("[name='type']");
    const childInputsCont = form.querySelector(".js-locations");  

    childInputsCont?.querySelectorAll("input")?.forEach(input => {
      input.addEventListener("change", this._handleInputLocationChange.bind(this, childInputsCont, input));
    });

    inputs?.forEach(input => {
      const values = input.getAttribute("data-accepts");
          
      input.addEventListener("change", this._handleInputChange.bind(this, input, childInputsCont, values));
      input.closest(".single-input-wrap")?.addEventListener("mouseenter", (e) => {
        if (!e.target.classList.contains("is-active")) e.target.querySelector("img")?.setAttribute("src", e.target.querySelector("img").getAttribute("data-imgneg")); 
      });
      input.closest(".single-input-wrap")?.addEventListener("mouseleave", (e) => {
        if (!e.target.classList.contains("is-active")) e.target.querySelector("img")?.setAttribute("src", e.target.querySelector("img").getAttribute("data-imgpos"));
      });
    });
  }

  _handleInputLocationChange(childInputsCont, input) {
    childInputsCont?.querySelector("input[data-checked='true']")?.removeAttribute("data-checked");
    childInputsCont?.querySelector(".is-active")?.classList.remove("is-active");
    if (input.checked === true) {
      input.setAttribute("data-checked", true);
      input?.closest(".input-radio-cont").classList.add("is-active");
    }
  }

  _handleInputChange(input, childInputsCont, values) {
    childInputsCont?.querySelectorAll("select")?.forEach(select => {
      const patchedSelect = this.patchedSelects.find(el => el.select === select);
      patchedSelect?.hiddenOptions.forEach(opt => select.append(opt));
      select.value = select.querySelector("option")?.value;
    });
    childInputsCont?.classList.remove("is-disabled");
    childInputsCont?.querySelectorAll(".is-active")?.forEach(el => el.classList.remove("is-active"));
    childInputsCont?.querySelectorAll(".is-hidden")?.forEach(el => el.classList.remove("is-hidden"));    

    if (values.length) {
      const inputEls = Array.from(childInputsCont.querySelectorAll("input"));
      const optionEls = Array.from(childInputsCont.querySelectorAll("option"));
      let els;
      
      if (inputEls) {
        els = inputEls.concat(optionEls);
      }

      els?.forEach(el => {
        if (!values.includes(el.value)) {
          if (el.tagName === "INPUT") {
            el.closest(".single-input-wrap")?.classList.add("is-hidden");

          } else {
            el?.closest("select")?.querySelectorAll("option")?.forEach(option => {
              if (!values.includes(option.value)) {
                option.classList.add("is-hidden");
                const select = option.closest("select");
                
                /**
                 * add node to patchedSelects array
                 * with its options
                 */
                this._registerNodeToPatchedSelects(select, option);

                option.remove();
              }
            });

            // console.log(this.patchedSelects);

            if (el?.closest("select")?.querySelectorAll("option:not(.is-hidden)")?.length) {
              el.closest("select").value = el.closest("select").querySelector("option:not(.is-hidden)").value;
            } 
            
            if (el?.closest("select")?.querySelectorAll("option")?.length === el?.closest("select")?.querySelectorAll("option.is-hidden")?.length) {
              el?.closest("select")?.classList.add("is-hidden");
            
            } else {
              el?.classList.add("is-hidden");
            }
          }

        } else {
          if (el.tagName === "INPUT") {
            el.closest(".single-input-wrap")?.classList.remove("is-hidden");

          } else {
            el.classList.remove("is-hidden");
          }
        }
      });
    } 

    if (input.checked === true) {
      input.setAttribute("data-checked", true);
      this.panel.querySelector(".single-input-wrap.is-active img")?.setAttribute("src", this.panel.querySelector(".single-input-wrap.is-active img").getAttribute("data-imgpos"));
      this.panel.querySelector(".single-input-wrap.is-active")?.classList.remove("is-active");
      input.closest(".single-input-wrap")?.classList.add("is-active");
      input.previousElementSibling?.setAttribute("src", input.previousElementSibling?.getAttribute("data-imgneg"));      

      if (childInputsCont) {
        childInputsCont.querySelector(".single-input-wrap:not(.is-hidden) input").checked = true;
        childInputsCont.querySelector(".single-input-wrap:not(.is-hidden) input")?.setAttribute("data-checked", true);
        childInputsCont.querySelector(".single-input-wrap:not(.is-hidden) .input-radio-cont").classList.add("is-active");
      }
    }    
  }

  /**
   * @param {HTMLSelectElement} select 
   * @param {HTMLOptionElement} option 
   **/
  _registerNodeToPatchedSelects(select, option) {
    const patchedSelect = this.patchedSelects.find(entry => entry.select === select);

    if (!patchedSelect) {
      this.patchedSelects.push({
        select: select,
        hiddenOptions: [option]
      });

    } else {
      !patchedSelect.hiddenOptions.includes(option)
        && patchedSelect.hiddenOptions.push(option);
    }
  }
}